/**
 * The four standing promises shown right above the checkout total — the open
 * Iris recommendation from 2026-08-24. Wording is the knowledge base's: "no
 * credit check, no interest, no hidden fees", price protection from the
 * deposit, and Defera Credit framed as eligibility ("select bookings"), never
 * as a mechanism (desk Hard Rule #13). Parity-tested in tommy-grounding.
 */
import { ShieldCheck, Percent, Lock, RotateCcw } from 'lucide-react';

export const CHECKOUT_REASSURANCE = [
  { id: 'credit', icon: ShieldCheck, label: 'No credit check' },
  { id: 'interest', icon: Percent, label: '0% interest' },
  { id: 'price', icon: Lock, label: 'Price protected from today' },
  { id: 'credit_cancel', icon: RotateCcw, label: 'Defera Credit on select cancellations' },
];
